import React from 'react';
import Markup from './markup/Markup';
import './css/plugins.css';
import './css/style.css';
import './css/templete.css';
import './css/skin/skin-1.css';
import './plugins/slick/slick.min.css';
import './plugins/slick/slick-theme.min.css';

import { inject } from '@vercel/analytics';
inject();

//import { SpeedInsights } from "@vercel/speed-insights/react"
///<SpeedInsights />

function App() {
  return (
    <div className="App">
      <Markup />
    </div>
  );
}

export default App;
